import ActionsBuilder from '../../../../utils/actions/ActionsBuilder';

export const IDENTIFIER = '[ADMINS]';
export const actions = ActionsBuilder.buildList(IDENTIFIER);
